export default "__VITE_ASSET__Durq0eiZ__"